import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { useState, useEffect } from "react";
import MarkdownRenderer from "../../MarkdownRenderer";
import { convertMdxToMd } from "../../../lib/convertMdx";
import siMonitoringFile from "../../../assets/markDownFiles/si/si4.md";

const SiMonitoring = () => {
  const [content, setContent] = useState("");
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    if (typeof siMonitoringFile === "string" && siMonitoringFile.startsWith("/static")) {
       fetch(siMonitoringFile)
      .then((res) => res.text())
      .then((raw) => {
        console.log(JSON.stringify(raw.slice(0, 200))); 
        setContent(convertMdxToMd(raw));
      });
         
    } else {
      console.log(JSON.stringify(siMonitoringFile.slice(0, 200)));
      setContent(convertMdxToMd(siMonitoringFile));
    }
  }, []);

  return (
    <Box sx={{ padding: "0" }}>
      <Typography
        sx={{
          color: "#e54f9c",
          fontWeight: "900",
          fontSize: "0.8rem",
          marginBottom: "0.35rem",
          marginLeft: isDesktop ? "0" : "5%",
        }}
      >
        ACT Sports Integrity
      </Typography>
      {content ? (
        <MarkdownRenderer content={content} />
      ) : (
        <p>Loading...</p>
      )}
    </Box>
  );
};

export default SiMonitoring;

